var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('span',{staticClass:"cursor-pointer text-[#666]",on:{"click":_vm.toPre}},[_vm._v("返回")]),_c('i',{staticClass:"el-icon-arrow-right text-[#666]"}),_c('span',{staticClass:"text-[#333] font-[600]"},[_vm._v(_vm._s(_vm.breadTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }